<template>
  <div class="content-wrappper">
    <div class="row dashboard-container">
      <router-view :account_id="account_id" :userId="userId" :roleId="roleId"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  props: ['account_id', 'userId', 'roleId'],
  data() {
    return {};
  },
  components: {},
  methods: {},
  created() {},
};
</script>
<style scoped>
.dashboard-container {
  margin-right: 0px;
  margin-left: 0px;
}
</style>
